import { memo, useMemo } from 'react'
import { Chip } from 'src/components/shared/Chip'
import { teamMemberStatusTitles } from 'src/constants/team/team-members/constants'
import { TeamMemberStatus } from 'src/constants/team/team-members/enums'
import { colors } from 'src/theme'
import tw from 'twin.macro'

interface Props {
  status: TeamMemberStatus
}

const teamMemberStatusMap = {
  [TeamMemberStatus.Active]: {
    color: colors.COLORS_GREEN_500,
    text: teamMemberStatusTitles[TeamMemberStatus.Active],
    bgStyle: tw`bg-[rgba(230, 249, 233, 1)]`,
  },
  [TeamMemberStatus.Deactivated]: {
    color: colors.COLORS_RED_500,
    text: teamMemberStatusTitles[TeamMemberStatus.Deactivated],
    bgStyle: tw`bg-[rgba(255, 232, 238, 1)]`,
  },
}

const getTeamMemberStatusParams = (status: TeamMemberStatus) =>
  teamMemberStatusMap[status] || {
    color: colors.SHADES_GREY_500,
    text: status,
    bgStyle: tw`bg-[rgba(218, 217, 224, 1)]`,
  }

const TeamMemberStatusChipComponent = ({ status }: Props) => {
  const params = useMemo(() => getTeamMemberStatusParams(status), [status])

  return (
    <div css={tw`flex items-center`}>
      <div css={tw`py-1 rounded-[10px]`}>
        <Chip className={params.bgStyle} textColor={params.color} text={params.text} />
      </div>
    </div>
  )
}

export const TeamMemberStatusChip = memo(TeamMemberStatusChipComponent)
